import { createUseStyles } from '../../theme/theming';

const useTilesStyles = createUseStyles((theme) => {
  return {
    tileParentDiv: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      fontFamily: theme?.typography?.fontFamily,
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      padding: ({ isMobile } = {}) =>
        isMobile
          ? `24px ${theme.spacing.padding.small}px`
          : `${theme.spacing.padding.small}px ${theme.spacing.padding.medium}px`
    },
    tileDiv: {
      width: '236px',
      // height: '160px',
      aspectRatio: '3/2',
      position: 'relative',
      borderRadius: '16px',
      overflow: 'hidden',
      cursor: 'pointer'
    },
    tileImg: {
      objectFit: 'cover',
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%'
    },
    title: {
      position: 'absolute',
      top: '12%',
      left: '7%',
      color: 'white',
      fontWeight: theme.typography.fontWeight.semiBold,
      fontSize: theme.typography.fontSize.h5,
      width: '150px'
    },

    row: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      flexWrap: 'wrap',
      width: '100%',
      gap: '24px'
    },

    header: {
      fontWeight: theme.typography.fontWeight.bold,
      fontSize: theme.typography.fontSize.h2,
      lineHeight: '46px',
      textAlign: 'center',
      color: '#2D2D2D'
    },
    headerTitle: {
      fontWeight: theme.typography.fontWeight.regular,
      fontSize: theme.typography.fontSize.subHead,
      lineHeight: '46px',
      color: '#7D8592',
      marginBottom: theme.spacing.margin.tiny,
      textAlign: 'center'
    },
    '@media screen and (max-width: 767px)': {
      tileDiv: {
        width: '100%'
      },
      headerTitle: {
        lineHeight: '16px'
      },
      row: {
        marginTop: '24px',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '12px'
      }
    }
  };
});

export default useTilesStyles;
